import { render } from "./ExternalSearchRequestForm.vue?vue&type=template&id=2af5b4f1&ts=true"
import script from "./ExternalSearchRequestForm.vue?vue&type=script&lang=ts"
export * from "./ExternalSearchRequestForm.vue?vue&type=script&lang=ts"

import "./ExternalSearchRequestForm.vue?vue&type=style&index=0&id=2af5b4f1&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__